module.exports = __webpack_public_path__ + "img/kovy@2x.849bf9d1.webp";